import React from 'react';
import { toast, ToastContainer ,  Slide } from "react-toastify";
require('react-toastify/dist/ReactToastify.css');
require ('./styles.css');

import {getParameterCaseInsensitive} from "sis_ui/utils/functions";

const getDefaultConfiguration = () => {
  const configuration = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    draggable: true,
    closeButton: false,
    transition: Slide,
    draggablePercent: 30,
    theme:'colored'
  };

  return configuration;
};

const Msg = ({ type ,message, closeToast }) => {
  let typeOfIcon;
    switch(type) {
      case "success" : 
        typeOfIcon =  <i className="fa fa-check-circle"/>;
        break;
      case "warning" :
        typeOfIcon =  <i className="fa fa-exclamation-triangle"/>;
        break;
      case "error" : 
        typeOfIcon = <i className="fa fa-exclamation-circle" />;
        break;
      case "info" : 
        typeOfIcon = <i className="fa fa-info-circle"/>;
        break;
      default: 
        typeOfIcon = <i className="fa fa-info-circle"/>;
        break;
    }
  return (
    <div className="notifContainer">
      <div className="notifCell icon">
        {typeOfIcon}
      </div>
      <div className="notifCell msg" dangerouslySetInnerHTML={{ __html: message }} ></div>
      <div className="notifCell closeBtn">
        <i onClick={closeToast} className="fa fa-times"></i>
      </div>
    </div>
  )
}

function drawMessage (type, message, options) {
  const defaultConfiguration = getDefaultConfiguration();
  const mergedConfiguration = {...defaultConfiguration , ...options}; 
  let toastID;
  if (typeof(message) !== 'string') {
    message.forEach( msg => {
      let msgType = getParameterCaseInsensitive(msg,"TYPE");
      if (typeof msgType === 'undefined') {
        msgType = type;
      } 
      msgType = msgType.toLowerCase();
      toastID = toast (
        <Msg message={getParameterCaseInsensitive(msg,"MESSAGE")}
            type={msgType}
        />,
        {
          type: msgType,
          ...mergedConfiguration,
        }
      );
      if (navigator.appName.indexOf("Internet Explorer")!=-1 && navigator.appVersion.indexOf("MSIE 9") > -1) {
        // ie9
        setTimeout(()=>{
          toast.dismiss(toastID);
        },5000)
      }
    })
  } else {
    toastID = toast (
      <Msg message={message}
          type={type.toLowerCase()}
      />, 
      { type: type.toLowerCase(),
        ...mergedConfiguration, }
    );
    if (navigator.appName.indexOf("Internet Explorer")!=-1 && navigator.appVersion.indexOf("MSIE 9") > -1) {
      // ie9
      setTimeout(()=>{
        toast.dismiss(toastID);
      },5000)
    }
  }

  return toastID;
}  

var MsgBox = {
  drawMessage: drawMessage,
  dismiss: toast.dismiss,
  ToastContainer
}


export default MsgBox;


